import { InfoCircleTwoTone } from "@ant-design/icons";
import { FirestoreDoc } from "@p0security/frontend-core/react";
import { Finding } from "@p0security/shared/types/assessment/finding";
import { Flex, Spin, Typography } from "@p0security/ui";
import { GraphTooltip } from "components/GraphTooltip";
import { GithubIcon } from "components/Integrations/GithubIcon";
import { JiraIcon } from "components/Integrations/Jira/Jira";

export const FindingAssignment: React.FC<{
  finding: FirestoreDoc<Finding>;
}> = ({ finding }) => {
  const { assignment, issue, remediation } = finding.data;
  const epicKey = finding.data.issue?.epicKey;

  return (
    <Flex align="baseline" gap="1em">
      {assignment &&
        (assignment.status === "complete" && assignment.assignee ? (
          <Typography.Paragraph>
            Assigned to {assignment.assignee}{" "}
            <GraphTooltip
              title={
                <div>
                  This findings was assigned to {assignment.assignee} for the
                  following reason:
                  <br />
                  {assignment.reason}
                </div>
              }
            >
              <InfoCircleTwoTone />
            </GraphTooltip>
          </Typography.Paragraph>
        ) : assignment.status === "assigning" ? (
          <Typography.Paragraph>
            <Spin /> Determining owner
          </Typography.Paragraph>
        ) : assignment.status === "remediating" ? (
          <Typography.Paragraph>
            <Spin /> Remediating finding
          </Typography.Paragraph>
        ) : assignment.status === "tracking" ? (
          <Typography.Paragraph>
            <Spin /> Creating issue
          </Typography.Paragraph>
        ) : null)}
      <Flex gap="1em">
        {issue && (
          <Typography.Text type="secondary">
            <Typography.Link
              href={issue.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {JiraIcon}&nbsp;View issue
            </Typography.Link>
            {epicKey && (
              <>
                &nbsp;| Linked to Epic:{" "}
                <Typography.Text code>{epicKey}</Typography.Text>
              </>
            )}
          </Typography.Text>
        )}
        {remediation && (
          <Typography.Link target="_blank" href={remediation.link}>
            {GithubIcon}&nbsp;View PR
          </Typography.Link>
        )}
      </Flex>
    </Flex>
  );
};
